var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsApiGateway(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-27 0 310 310",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,91.042 L40.848,93.617 L0.559,91.047 L67.199,84.66 L103,91.042",
    fill: "#634B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.055,87.45 L103,91.042 L103,18.636 L67.055,0.661 L64.295,3.641 L64.295,84.369 L67.055,87.45",
    fill: "#D9A740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.559,18.594 L67.055,0.597 L67.055,87.45 L0.559,91.047 L0.559,18.594",
    fill: "#886A2A"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,91.042 L62.152,93.617 L102.441,91.047 L35.991,83.93 L0,91.042",
    fill: "#634B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.945,87.45 L0,90.935 L0,18.31 L35.945,0.365 L37.6,3.456 L37.6,84.737 L35.945,87.45",
    fill: "#886A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.441,18.594 L35.945,0.597 L35.945,87.45 L102.441,91.047 L102.441,18.594",
    fill: "#D9A740"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,3.486 L40.848,0.91 L0.559,3.481 L66.909,10.188 L103,3.486",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.055,7.078 L103,3.486 L103,75.891 L67.055,93.866 L65.167,89.755 L65.167,10.772 L67.055,7.078",
    fill: "#D9A740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.559,75.934 L67.055,93.931 L67.055,7.078 L0.559,3.481 L0.559,75.934",
    fill: "#886A2A"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.486 L62.152,0.91 L102.441,3.481 L35.51,10.769 L0,3.486",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.945,7.078 L0,3.486 L0,75.891 L35.945,93.866 L38.124,90.626 L38.124,10.769 L35.945,7.078",
    fill: "#886A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.441,75.934 L35.945,93.931 L35.945,7.078 L102.441,3.481 L102.441,75.934",
    fill: "#D9A740"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.553,106.629 L73.519,100.848 L139.333,110.167 L145.002,113.428 L113.036,116.926 L40.553,106.629",
    fill: "#634B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.447,106.629 L72.481,100.848 L3.833,111.5 L0.998,113.428 L32.964,116.926 L105.447,106.629",
    fill: "#634B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.553,204.899 L73.519,210.68 L139.167,201.5 L145.002,198.1 L113.036,194.602 L40.553,204.899",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.447,204.899 L72.481,210.68 L3.333,200.833 L0.998,198.1 L32.964,194.602 L105.447,204.899",
    fill: "#FAD791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.002,113.428 L145.002,77.641 L111.289,66.616 L111.289,19.776 L73,0.634 L73,0.635 L71.403,3.178 L71.112,305.766 L73,309.657 L111.289,290.515 L111.289,244.912 L145.002,233.887 L145.002,198.1 L111.289,204.035 L111.289,107.493 L145.002,113.428",
    fill: "#D9A740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.711,19.776 L34.711,66.616 L0.998,77.641 L0.998,113.428 L34.711,107.493 L34.711,204.035 L0.998,198.1 L0.998,233.887 L34.711,244.912 L34.711,290.515 L73,309.657 L73,0.634 L34.711,19.776",
    fill: "#886A2A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsApiGateway);
export default __webpack_public_path__ + "static/media/aws-api-gateway.10ccc98fec50d55d8fa61a40aa865379.svg";
export { ForwardRef as ReactComponent };